import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

// [三方充值活动主页] http://wiki.xunlei.cn/pages/viewpage.action?pageId=178753864
export const homepage = createAsyncThunk(
  'Saada/CreditCardRecharge/homepage',
  async (p: any, store: any) => {
    const resp = await http.post(
      'live/hiya_socialize/tpr_act_homepage',
      {
        ...p,
      },
      {
        store,
      }
    )
    return resp.data
  }
)

// [三方充值活动主页] http://wiki.xunlei.cn/pages/viewpage.action?pageId=179470353
export const tpr_act_receive_reward = createAsyncThunk(
  'Saada/CreditCardRecharge/tpr_act_receive_reward',
  async (p: {stage_id: number}, store: any) => {
    const resp = await http.post(
      'live/hiya_socialize/tpr_act_receive_reward',
      {
        ...p,
      },
      {
        store,
        xcErrorToast: true,
      }
    )
    return resp.data
  }
)

export enum RewardStatus {
  未达成 = 0,
  已达成未领取 = 1,
  已领取 = 2,
}

export interface InitialStateType {
  recharge_cents: number // 已充值金额（单位：美分，前端展示需除以100转换为美元）
  task_list: {
    id: number // 任务ID
    status: RewardStatus // 任务状态：0=未完成，1=已完成未领取，2=已领取
    target: number // 目标充值金额（单位：美分）
    reward: number // 完成任务奖励的金币数
  }[] // 充值任务列表
  countdown: number // 任务倒计时（单位：秒）
}

const initialState: Partial<InitialStateType> = {}

export const SaadaCreditCardRechargeSlice = createSlice({
  name: 'Animal_Hawk',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(homepage.fulfilled, (state, action) => {
      Object.assign(state, {...action.payload.data})
    })
  },
})

export default SaadaCreditCardRechargeSlice.reducer

export const useSaadaCreditCardRechargeState = () => {
  const data = useSelector((state) => {
    return state.Animal_Hawk
  })
  return data
}
